import React, { useEffect, useState } from "react";
import { Toast } from "react-bootstrap";
import { ToastProps } from "./Toast.props";
import "./style.scss";

const ToastComponent = React.memo<ToastProps>(
    ({ isShow, title, className, time = 3000 }) => {
        const [showToast, setShowToast] = useState(false);

        useEffect(() => {
            setShowToast(isShow);
            if (isShow) {
                setTimeout(() => {
                    setShowToast(false);
                }, time);
            }
        }, [isShow]);

        if (!showToast) {
            return null;
        }

        return (
            <Toast
                show={showToast}
                className={`rtl ${className}`}
                data-testid="ToastComponent"
            >
                <Toast.Body>{title}</Toast.Body>
            </Toast>
        );
    }
);

export default ToastComponent;
